module.exports = __webpack_public_path__ + "static/media/check-circle.0a1e986e.svg";